import React from 'react';
import HeroSection from '../components/MusicMarketing/HeroSection';
import ServicesSection from '../components/MusicMarketing/ServicesSection';
import TestimonialsSection from '../components/MusicMarketing/TestimonialsSection';
import Navbar from '../components/ArtisttoHeader';
import ArtisttoFooter from '../components/ArtisttoFooter';

const MusicMarketing = () => {
  return (
    <div className="min-h-screen">
        <Navbar />
            <div className="font-inter">
      <HeroSection />
      <ServicesSection /></div>
      {/* <TestimonialsSection /> */}
      <ArtisttoFooter />
    </div>
  );
};

export default MusicMarketing;
